import { useContext, useEffect, useState } from 'react'
import { usePrevious } from 'react-use'
import { OVERLAY_TRANSITION_DURATION } from '../constants'
import { UgeEditorContext } from '../contexts/editor'
import UgeEditor from '../types/editor'
import CropOverlay from './crop'

const Overlay = () => {
    const { activeEditor } = useContext(UgeEditorContext)
    const previousEditor = usePrevious(activeEditor)
    const [visibleEditor, setVisibleEditor] = useState<UgeEditor>(activeEditor)

    useEffect(() => {
        const wasCrop = previousEditor === 'crop'
        const delay = setTimeout(
            () => {
                setVisibleEditor(activeEditor)
            },
            wasCrop ? OVERLAY_TRANSITION_DURATION : 0
        )

        return () => {
            clearTimeout(delay)
        }
    }, [activeEditor])

    switch (visibleEditor) {
        case 'crop':
            return <CropOverlay hidden={activeEditor !== 'crop'} />
        default:
            return null
    }
}

export default Overlay
